export const SECRET_OBJECT_ATTRIBUTE_KEY = 'secret_clues';

export const SECRET_OBJECT_ATTRIBUTE_KEYS = new Set([
  SECRET_OBJECT_ATTRIBUTE_KEY,
  'found_object_id',
  'possible_loss_locations',
  'public_transport',
]);

export function validateSecretCluesValue(
  objectAttributes: Record<string, unknown> | null | undefined
): string | null {
  const value = objectAttributes?.[SECRET_OBJECT_ATTRIBUTE_KEY];
  if (typeof value !== 'string' || !value.trim()) {
    return 'Renseignez le détail secret pour continuer.';
  }
  return null;
}

export function isSecretObjectAttributeKey(key: string): boolean {
  if (SECRET_OBJECT_ATTRIBUTE_KEYS.has(key)) {
    return true;
  }
  if (key.startsWith('_')) {
    return true;
  }
  return /(secret|discret|fond|wallpaper|ecran|pin|verrou|code\s*pin|mot_de_passe|password)/i.test(key);
}
